// extracted by mini-css-extract-plugin
export default {"duration":"app-qualityControl-schedule-ScheduleItem-module__OiU8I6HsQoTOziMDaHZd","hours":"app-qualityControl-schedule-ScheduleItem-module__pXvsdv3295IiYI4QJaIw"};